import { Box, Grid, Hidden, Typography } from "@mui/material";
import { setHours } from "date-fns";
import { useState, useEffect } from "react";
import {
  END_DATE,
  END_DAY_OF_FESTIVAL,
  MONTH,
  START_DATE,
  START_DAY_OF_FESTIVAL,
  YEAR,
} from "../constants/festivalDates";

const commonStyles = {
  letterSpacing: "-.025em",
  lineHeight: 1,
  marginRight: "16px",
  fontWeight: 700,
};

export default function DaysUntilBanner() {
  const [dateString, setDateString] = useState("");

  const startDate = START_DATE;

  // Setup countdown interval
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      let diff = Math.max(
        0,
        Math.floor((startDate.getTime() - now.getTime()) / 1000)
      );
      let days = Math.floor(diff / (24 * 60 * 60));
      let hours = Math.floor((diff % (24 * 60 * 60)) / (60 * 60));
      let minutes = Math.floor((diff % (60 * 60)) / 60);
      let seconds = diff % 60;

      setDateString(`${days}  :  ${hours}  :  ${minutes}  :  ${seconds}`);
    }, 1000);
    return () => clearInterval(interval);
  }, [startDate]);

  // if date is in the past set to true
  const festivalIsOver = new Date() > setHours(new Date(END_DATE), 12);

  const festivalIsOccurring =
    new Date() >= setHours(new Date(START_DATE), 12) && !festivalIsOver;

  return (
    <Box
      sx={{
        height: 60,
        width: "100%",
        backgroundColor: "teal.light",
      }}
    >
      <Grid
        sx={{ height: "100%" }}
        container
        justifyContent="center"
        alignItems="center"
        alignContent="center"
      >
        <Hidden only={["xs", "sm"]}>
          <Box sx={{ display: "flex", marginRight: "50px" }}>
            <Typography sx={commonStyles}>
              {MONTH} {START_DAY_OF_FESTIVAL}-{END_DAY_OF_FESTIVAL}, {YEAR}
            </Typography>
          </Box>
        </Hidden>

        {festivalIsOver ? (
          <Box>
            <Typography sx={[commonStyles, { fontSize: 11 }]}>
              We hope you enjoyed Amplitude Festival {YEAR}!
            </Typography>
          </Box>
        ) : festivalIsOccurring ? (
          <Box>
            <Typography sx={[commonStyles, { fontSize: 11 }]}>
              Happening Now!
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography
              sx={[commonStyles, { lineHeight: "29px", fontSize: 22 }]}
            >
              {dateString}
            </Typography>
            <Typography sx={[commonStyles, { fontSize: 11 }]}>
              Countdown to Amplitude Festival {YEAR}
            </Typography>
          </Box>
        )}
      </Grid>
    </Box>
  );
}
